import axiosInstance from '../axios';
import { LoginPayload, LoginResponse } from '../../type/Auth';
import { useMutation } from '@tanstack/react-query';

const loginUser = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response: any = await axiosInstance.post<LoginResponse>('/auth/adminLogin', payload);
  return response.data;
};


export const useLogin = () => {
  return useMutation<LoginResponse, Error, LoginPayload>({
    mutationFn: loginUser,
  });
};

const loginStaff = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response: any = await axiosInstance.post<LoginResponse>('/auth/login', payload);
  return response.data;
};


export const useStaffLogin = () => {
  return useMutation<LoginResponse, Error, LoginPayload>({
    mutationFn: loginStaff,
  });
};

const forgotPasswordUser = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response: any = await axiosInstance.post<LoginResponse>('/auth/resetPassword', payload);
  return response.data.data;
};


export const useForgotPassword = () => {
  return useMutation<LoginResponse, Error, LoginPayload>({
    mutationFn: forgotPasswordUser,
  });
};

// Change Passsword
const changePassword = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response: any = await axiosInstance.post<LoginResponse>('/auth/changePassword', payload);
  return response.data;
};

export const useChangePassword = () => {
  return useMutation<LoginResponse, Error, LoginPayload>({
    mutationKey: ['changePassword'],
    mutationFn: changePassword,
  });
};

// Reset Passsword
const resetPassword = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response: any = await axiosInstance.post<LoginResponse>('/auth/resetPassword', payload);
  return response.data;
};

export const useResetPassword = () => {
  return useMutation<LoginResponse, Error, LoginPayload>({
    mutationKey: ['resetPassword'],
    mutationFn: resetPassword,
  });
};